export default __webpack_public_path__ + "static/media/1.36b96fc1.jpg";